import { StyledNewProductForm } from './style';
import { Table } from '../../Table';
import { useIntl } from 'react-intl';
import { InfrastructureProps } from 'interfaces/BackendModels';
import { Checkbox } from 'ui/Checkbox';
import React, { useMemo } from 'react';
import { useAuth } from 'hooks/useAuth';
import { ResponsiveWrapper } from 'admin/components/ResponsiveWrapper';
import MobileList from 'admin/components/MobileLayout/MobileList';

interface StructureProps {
  farmId?: number | null;
  defaultChecked?: boolean;
}

export const NewProductsStructureForm = ({
  farmId,
  defaultChecked = true,
}: StructureProps) => {
  const intl = useIntl();
  const { user } = useAuth();

  const stableFilter = useMemo(() => {
    return { farmId: farmId ?? user?.farmId };
  }, [user?.farmId, farmId]);

  const columns = [
    {
      title: intl.formatMessage({ id: 'delivery.address' }),
      dataIndex: 'address_pak',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.name' }),
      dataIndex: 'object_name',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.emarket' }),
      width: 130,
      render: (record: InfrastructureProps) => {
        return (
          <Checkbox
            name={['infrastructures', record.id.toString(), 'emarket']}
            initialValue={defaultChecked}
          />
        );
      },
    },
    {
      title: intl.formatMessage({ id: 'general.wholesale' }),
      render: (record: InfrastructureProps) => (
        <Checkbox
          name={['infrastructures', record.id.toString(), 'wholesale']}
          initialValue={defaultChecked}
        />
      ),
    },
  ];

  const mobileItems = {
    coverFields: [
      {
        name: 'title',
        render: () => intl.formatMessage({ id: 'general.address' }),
      },

      {
        name: 'address_pak',
        render: (value: string) => value,
      },
    ],
    bodyFields: [
      {
        name: 'object_name',
        label: intl.formatMessage({ id: 'general.structure_unit' }),
        render: (value: string) => value,
      },
    ],
    bodyTripleSectionFields: [
      {
        name: 'title',
        label: intl.formatMessage({ id: 'general.emarket' }),
        render: (value: string, record: InfrastructureProps) => {
          return (
            <Checkbox
              name={['infrastructures', record.id.toString(), 'emarket']}
              initialValue={defaultChecked}
            />
          );
        },
      },
      {
        name: 'title',
        label: intl.formatMessage({ id: 'general.wholesale' }),
        render: (value: string, record: InfrastructureProps) => (
          <Checkbox
            name={['infrastructures', record.id.toString(), 'wholesale']}
            initialValue={defaultChecked}
          />
        ),
      },
    ],
  };

  const emptyText = intl.formatMessage({ id: 'product.no_infrastructures' });

  return (
    <StyledNewProductForm className={'products-structure-form'}>
      <ResponsiveWrapper
        desktopComponent={
          <Table
            className={'products-structure-table'}
            url={'/api/v2/farm/infrastructures'}
            columns={columns}
            filter={stableFilter}
            locale={{ emptyText }}
          />
        }
        mobileComponent={
          <MobileList
            className={'create-edit-product-infrastructure-mobile-list'}
            url={'/api/v2/farm/infrastructures'}
            bodyFields={mobileItems.bodyFields}
            coverFields={mobileItems.coverFields}
            bodyTripleSectionFields={mobileItems.bodyTripleSectionFields}
            emptyText={emptyText}
          />
        }
      />
    </StyledNewProductForm>
  );
};
